export default __webpack_public_path__ + "static/media/change_item_details.bf9c7740.svg";